import React, { useState } from 'react';
import _ from 'lodash';
/**
 * トグルスイッチに関するカスタムフック
 * @param {function} setLeftMovedUserIds 左側に移動済みのユーザーを変更する関数
 * @param {function} setRightMovedUserIds 右側に移動済みのユーザーを変更する関数
 **/
function useToggleSwitch(setLeftMovedUserIds, setRightMovedUserIds) {
  // 移動予約されているユーザー達
  const [leftMoveScheduledUserIds, setLeftMoveScheduledUserIds] = useState([]);
  const [rightMoveScheduledUserIds, setRightMoveScheduledUserIds] = useState(
    []
  );

  const handleMoveToRight = () => {
    setLeftMovedUserIds(prevStatus => {
      return _.difference(prevStatus, rightMoveScheduledUserIds);
    });
    setRightMovedUserIds(prevStatus => {
      return _.concat(prevStatus, rightMoveScheduledUserIds);
    });
    setRightMoveScheduledUserIds([]);
  };

  const handleMoveToLeft = () => {
    setLeftMovedUserIds(prevStatus => {
      return _.concat(prevStatus, leftMoveScheduledUserIds);
    });
    setRightMovedUserIds(prevStatus => {
      return _.difference(prevStatus, leftMoveScheduledUserIds);
    });
    setLeftMoveScheduledUserIds([]);
  };

  /**
   * トグルスイッチを描画する
   **/
  const RenderToggleSwitch = () => {
    return (
      <div className='dual-panel__navi'>
        <div className='dual-panel__navi-item'>
          <button className='btn-move__right' onClick={handleMoveToRight} />
        </div>
        <div className='dual-panel__navi-spacer' />
        <div className='dual-panel__navi-item'>
          <button className='btn-move__left' onClick={handleMoveToLeft} />
        </div>
      </div>
    );
  };

  return [
    {
      rightMoveScheduledUserIds,
      leftMoveScheduledUserIds,
    },
    {
      setRightMoveScheduledUserIds,
      setLeftMoveScheduledUserIds,
      RenderToggleSwitch,
    },
  ];
}

export { useToggleSwitch };



// WEBPACK FOOTER //
// ./src/components/lwUser/toggleSwitch.jsx